import { schema } from 'normalizr'

// VEHICLES
const vehicle = new schema.Entity('vehicles');
export const vehicleList = new schema.Array(vehicle);
// LOCATIONS
const location = new schema.Entity('locations');
export const locationList = new schema.Array(location);
// USER
const user = new schema.Entity('users');
export const userList = new schema.Array(user);
// JOBS
const jobOptions = { idAttribute: 'externalId' };
const job = new schema.Entity('jobs', {}, jobOptions);
export const jobItem = new schema.Entity('jobs', {}, jobOptions);
// ATTCHMENT
const jobAttachment = new schema.Entity('jobAttachments');
export const jobAttachments = new schema.Array(jobAttachment);
// RUNSHEETS
const runsheetDefinition = { jobs: [job], location: location, user: user, vehicle: vehicle };
const runsheetOptions = { idAttribute: 'externalId' };
export const runsheet = new schema.Entity('runsheets', runsheetDefinition, runsheetOptions);
export const runsheetList = new schema.Array(runsheet);



// WEBPACK FOOTER //
// ./src/actions/schema.js